import { Inject, Options, Vue } from "vue-property-decorator";
import { IlpDirectorRequest } from "@/shared/modules/typescript-trustapi-client/models";
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import ModalBox from "@/shared/components/modal-box/index.vue";
import { TrustAPI } from "@/shared/modules/trust-api";
import { EventEmitter } from "events";
import store from "@/trust-admin-app/store";
import V3DatePicker from 'vue3-datepicker';
import { ref } from 'vue'
import AlertBox from "@/shared/components/alert-box/index.vue";

@Options({
  props: {
    directorRequest: {},
  },
  components: {
    ModalBox,
    LoadingSpinner,
    V3DatePicker,
    AlertBox,
  }
})
export default class AddEditDirectorModal extends Vue {
  private directorRequest!: IlpDirectorRequest;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  showAddEditModal!: boolean;

  // date picker
  private today = ref(new Date());

  private canSubmit = false;

  private showFullScreenFileViewer = false;
  private showStepper = false;
  private halfScreen = false;
  private show = false;
  private isLoadingData = false;
  private isFormDirty = false;
  private showCancelAlert = false;
  private editMode = false;

  private headerText = '';
  private line2Text = '';
  private existingLawId = false;
  private existingLsId = false;
  private existingName = false;


  mounted(): void {
    this.show = this.showAddEditModal;
    this.editMode = this.directorRequest.id !== 0;
    this.headerText = this.directorRequest.id === 0 ? 'Add new ILP Director' : 'Edit ILP Director';
    this.line2Text =  this.directorRequest.firstName + ' ' + this.directorRequest.lastName;
  }

  private mandatoryCheck() {
    this.isFormDirty = true;
    const _firstName: boolean = this.directorRequest.firstName.trim() !== '';
    const _lastName: boolean = this.directorRequest.lastName.trim() !== '';

    const _position: boolean = this.directorRequest.position.trim() !== '';
    this.canSubmit = _firstName && _lastName && _position;

  }

  get from(): Date {
    return this.directorRequest.commencedDate;
  }

  get submitBtnText(): string {
    return this.directorRequest.id === 0 ? 'Add new ILP Director' : 'Save changes';
  }

  private cancelClicked() {
    if (this.isFormDirty) {
      this.showCancelAlert = true;
    } else {
      this.closeModal();
    }
  }

  private yesClicked() {
    this.closeModal();
  }

  private closeModal(): void {
    this.$emit('closeModal');
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private submit(): void {
    this.isLoadingData = true;
    this.apiService.PeopleApi?.apiV2PeopleSaveIlpDirectorPost(this.directorRequest)
      .then(res => {
        setTimeout(() => {
          this.$emit('updateTable', res);
          this.isLoadingData = false;
          this.closeModal();
        }, 250);
        if (this.directorRequest.id > 0) {
          this.eventCtrl.emit('show-snackbar', 'success', 'Record updated successfully..');
        } else {
          this.eventCtrl.emit('show-snackbar', 'success', 'Record is added successfully..');
        }
      })
      .catch(err => {
        console.log(err);
        this.eventCtrl.emit('show-snackbar', 'error', 'Error on submitting ILPdirector');
        this.isLoadingData = false;
      })
  }

}

